import dynamic from "next/dynamic";
import { Box } from "@chakra-ui/react";
import { ProjectDocument } from "~/core/types";
import RegistrationSuccessMessage from "../RegistrationSuccessMessage";

const ReactPlayer = dynamic(() => import("react-player/lazy"), { ssr: false });

export default function DetailsSection({
  project,
  isUserRegistered,
}: {
  project: ProjectDocument;
  isUserRegistered: boolean;
}) {
  return (
    <>
      {project.successMessage && isUserRegistered && (
        <Box mb={8} w={"100%"}>
          <RegistrationSuccessMessage
            inModal={false}
            message={project.successMessage}
          />
        </Box>
      )}
      {project?.video && (
        <Box mb={8}>
          <ReactPlayer width={"100%"} url={project?.video} light />
        </Box>
      )}
      <Box
        className="wysiwyg-container"
        fontFamily="'Poppins', sans-serif"
        color="descText"
        dangerouslySetInnerHTML={{
          __html: project.desc,
        }}
      />
    </>
  );
}
